import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="pt-12 pb-24 sm:py-16 md:py-24 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 px-4">
            Let's build something together
          </h2>
          <p className="text-base sm:text-xl text-slate-300 max-w-3xl mx-auto px-4">
            Whether you're interested in our ventures, consulting services, partnerships, or investment opportunities, we'd like to hear from you.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8 sm:mb-12 px-4">
          <a
            href="mailto:owlworklabs@gmail.com"
            className="flex items-center gap-3 text-base sm:text-lg hover:text-slate-300 transition-colors"
          >
            <Mail className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-sm sm:text-base">owlworklabs@gmail.com</span>
          </a>
          <a
            href="https://www.linkedin.com/company/owl-work-labs"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-base sm:text-lg hover:text-slate-300 transition-colors"
          >
            <Linkedin className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-sm sm:text-base">LinkedIn</span>
          </a>
          <div className="flex items-center gap-3 text-base sm:text-lg text-slate-300">
            <MapPin className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-sm sm:text-base">London, UK</span>
          </div>
        </div>

        <div className="pt-6 sm:pt-8 border-t border-slate-800 text-center text-slate-400 text-xs sm:text-sm px-4">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-4">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          </div>
          <p>© {new Date().getFullYear()} OwlWorkLabs Ltd. All rights reserved.</p>
          <p className="mt-1 text-slate-500">OwlWorkLabs Ltd · London, United Kingdom · Company No. 16713122</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;